module.exports = __webpack_public_path__ + "static/index/img/baikal-702.c890774b.jpg";